module.exports = __webpack_public_path__ + "img/left-arrow.f3c9288f.svg";